import React from 'react';
import Icon from './Icon';
import './ErrorState.css';

// Classifies an axios error into the three situations a student actually meets. Kept here so every screen
// words them the same way.
export function classifyError(err) {
  if (err && !err.response) return 'network';                 // no response at all: offline, DNS, server unreachable
  const status = err?.response?.status;
  if (status === 401) return 'session';
  if (status === 403) return 'forbidden';
  if (status === 404) return 'missing';
  return 'generic';
}

const COPY = {
  network: { icon: 'wifi-off', title: 'You appear to be offline', body: 'Check your connection and try again. Nothing you did was lost.' },
  session: { icon: 'lock', title: 'Your session has ended', body: 'Please sign in again to continue.' },
  forbidden: { icon: 'shield', title: 'This isn\'t available to you', body: 'If you think that is a mistake, tell us through Feedback.' },
  missing: { icon: 'search', title: 'We couldn\'t find that', body: 'It may have been removed or the link is out of date.' },
  generic: { icon: 'warning', title: 'Something went wrong', body: 'Please try again in a moment.' },
};

/**
 * Inline error panel. `kind` is one of network | session | forbidden | missing | generic, or pass `error`
 * (an axios error) and it is classified for you. Offers Retry when `onRetry` is given.
 */
export default function ErrorState({ kind, error, title, body, onRetry, compact = false }) {
  const k = kind || classifyError(error);
  const copy = COPY[k] || COPY.generic;
  return (
    <div className={`z-error${compact ? ' z-error--compact' : ''}`} role="alert">
      <span className="z-error-icon"><Icon name={copy.icon} size={compact ? 24 : 32} /></span>
      <div className="z-error-text">
        <div className="z-error-title">{title || copy.title}</div>
        <div className="z-error-body">{body || copy.body}</div>
      </div>
      {onRetry && (
        <button type="button" className="z-btn z-btn--secondary z-btn--sm z-error-retry" onClick={onRetry}>
          <Icon name="refresh" size={16} /> Try again
        </button>
      )}
    </div>
  );
}
